<template>
  <div class="performance-report-detail">
    <div class="header">履约报表详情</div>
    <div class="content">
      <!-- 基础信息 -->
      <div class="detail basic-msg">
        <div class="header">基础信息</div>
        <div class="content">
          <el-table
            tooltip-effect="dark"
            border
            style="width: 100%"
            :data="resData.list"
          >
            <el-table-column
              align="center"
              prop="str_demanded_date"
              label="需求日期"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_id"
              label="商家ID"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_supply"
              label="商家"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_market"
              label="市场"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_pg_group"
              label="代采组"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_pg_member"
              label="代采员"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="履约总览" name="sumUp">
          <!-- 报表汇总 （数量/金额） -->
          <div class="detail amount">
            <div class="header">
              <span style="color: #4e9fe8">
                （数量/金额，金额按计划代采单统计）
              </span>
            </div>
            <div class="content">
              <el-table
                tooltip-effect="dark"
                border
                style="width: 100%"
                :data="resData.list"
              >
                <el-table-column
                  align="center"
                  prop="24h_performance_rate"
                  label="24H履约率"
                >
                  <template #header>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div style="position: relative">
                        24H履约率<i class="el-icon-question" />
                      </div>
                      <div slot="content">
                        <div>
                          统计需求日期当天（截止至晚上24点）已履约的金额占比
                        </div>
                        <div>24H履约率 = 24H已履约金额 / 总需求金额</div>
                      </div>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      <div>
                        {{ scope.row["24h_performance_rate"] }}
                      </div>
                      <div style="color: #ccc">
                        {{ scope.row["24h_generate_status"] }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="48h_performance_rate"
                  label="48H履约率"
                >
                  <template #header>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div style="position: relative">
                        48H履约率<i class="el-icon-question" />
                      </div>
                      <div slot="content">
                        <div>
                          统计需求日期次日（截止至晚上24点）已履约的金额占比
                        </div>
                        <div>48H履约率 = 48H已履约金额 / 总需求金额</div>
                      </div>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      <div>
                        {{ scope.row["48h_performance_rate"] }}
                      </div>
                      <div style="color: #ccc">
                        {{ scope.row["48h_generate_status"] }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="360h_performance_rate"
                  label="360H履约率"
                >
                  <template #header>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div style="position: relative">
                        360H履约率<i class="el-icon-question" />
                      </div>
                      <div slot="content">
                        <div>
                          统计需求日期15天内（截止至晚上24点）已履约的金额占比
                        </div>
                        <div>360H履约率 = 360H已履约金额 / 总需求金额</div>
                      </div>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      <div>
                        {{ scope.row["360h_performance_rate"] }}
                      </div>
                      <div style="color: #ccc">
                        {{ scope.row["360h_generate_status"] }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="final_performance_rate"
                  label="总履约率"
                >
                  <template #header>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div style="position: relative">
                        总履约率<i class="el-icon-question" />
                      </div>
                      <div slot="content">
                        <div>统计截止当前所有已履约的金额占比</div>
                        <div>总履约率 = 总已履约金额 / 总需求金额</div>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  prop="delivery_accuracy"
                  label="货期准确率"
                >
                  <template #header>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div style="position: relative">
                        货期准确率<i class="el-icon-question" />
                      </div>
                      <div slot="content">
                        <div>统计商品到达承诺货期是所履约的金额占比</div>
                        <div>
                          货期准确率=货期到期时已履约金额/订货单总需求金额*100%
                        </div>
                      </div>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row["delivery_accuracy"] }}
                    </div>
                    <el-button
                      type="text"
                      size="small"
                      @click="handleDeliveryAccuracyClick(scope.row)"
                    >
                      查看明细
                    </el-button>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="总需求">
                  <el-table-column
                    align="center"
                    prop="str_all_pre"
                    label="前置仓发货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          前置仓发货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.pre_num }}</div>
                        <div>{{ row.pre_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="100"
                    prop="str_all_inventory"
                    label="现货发货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          现货发货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_all_plan"
                    label="订货单计划代采"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          订货单计划代采<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划中，总计划代采的商品数据。不含提前代采计划
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.plan_num }}/</div>
                        <div>{{ row.plan_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_all_sum"
                    label="小计"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          小计<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          总需求 = 前置仓发货 + 订货单计划代采
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.sum_num }}/</div>
                        <div>{{ row.sum_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="已履约">
                  <el-table-column
                    align="center"
                    prop="str_done_pre"
                    label="前置仓发货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          前置仓发货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.done_pre_num }}/</div>
                        <div>{{ row.done_pre_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="100"
                    prop="str_done_inventory"
                    label="现货发货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          现货发货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_done_plan"
                    label="订货单正常品已入库（含坏账）"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          订货单正常品已入库（含坏账）<i
                            class="el-icon-question"
                          />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划，开单后售前首次以正常品入库
                          或 首次申请为坏账时计入。
                          ①恢复欠货/正常品入库后调拨为不良品/坏账驳回均不再扣除。
                          ②已计入履约的，不再重复计算。
                          ③履约时间：代采欠货正常品入库-取生成包裹时间（快递包裹取揽收时间，无揽收时间时取仓库接收时间；无揽收时间且无接收时间时取最早的点货批次创建时间）；退换货欠货正常品入库
                          - 取入库时间；申请坏账 - 申请坏账时间。
                          ④入库来源=【代采欠货、退换货欠货、其它入库（退换货）】的退换区的商品被加入「商品盘亏表」时，消除「待履约」里的“退换货”，同时在“订货单正常品入库（含坏账）”里增加相应件数及金额。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.done_plan_num }}/</div>
                        <div>{{ row.done_plan_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_done_sum"
                    label="小计"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          小计<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          已履约 = 前置仓发货+现货发货 +
                          订货单正常品已入库（含坏账）
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.final_num }}/</div>
                        <div>{{ row.final_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="待履约">
                  <el-table-column
                    align="center"
                    prop="str_doing_plan"
                    label="待开单"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          待开单<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前在待开单的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.doing_plan_num }}/</div>
                        <div>{{ row.doing_plan_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_doing_owe"
                    label="订单欠货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          订单欠货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前在订单欠货（含由订单欠货转退款中）的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.doing_owe_num }}/</div>
                        <div>{{ row.doing_owe_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_doing_on_way"
                    label="配送在途"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          配送在途<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前在配送在途（即在途库存）、在途转欠货申请中的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.doing_on_way_num }}/</div>
                        <div>{{ row.doing_on_way_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_doing_reject"
                    label="退换货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          退换货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前为售前不良品在库、退换货待接收、退换货欠货、由售前退换货转退款中和转呆账的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.doing_reject_num }}/</div>
                        <div>{{ row.doing_reject_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_doing_sum"
                    label="小计"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          小计<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          待履约 = 待开单 + 订单欠货 + 配送在途 + 退换货
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.sum_doing_num }}/</div>
                        <div>{{ row.sum_doing_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="未履约">
                  <el-table-column
                    align="center"
                    prop="str_yet_stopped"
                    label="已断货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          已断货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前已断货的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.yet_stopped_num }}/</div>
                        <div>{{ row.yet_stopped_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_yet_ded"
                    label="转抵扣"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          转抵扣<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前已转抵扣（含待抵扣、已抵扣、待抵扣转退款中）的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.yet_ded_num }}/</div>
                        <div>{{ row.yet_ded_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_yet_refund"
                    label="已退款"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          已退款<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划当前已完成退款的商品数据。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.yet_refund_num }}/</div>
                        <div>{{ row.yet_refund_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_yet_cpin"
                    label="次品入库"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          次品入库<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计对应需求时间的代采计划商品，因开单后售前首次以次品入库或退换货欠货首次以次品入库，均计入“次品入库”里；
                          注意：恢复欠货并通过审核后，因商品重新回到代采欠货/在途库存，需要消掉对于的“次品入库”数据，并将数据返回到相应的表头记录里。
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="str_yet_sum"
                    label="小计"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          小计<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          未履约 = 已断货 + 转抵扣 + 已退款
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.sum_yet_num }}/</div>
                        <div>{{ row.sum_yet_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="不考核">
                  <el-table-column
                    align="center"
                    width="100"
                    prop="not_evaluate_inventory_num"
                    label="现货发货"
                  >
                    <template #header>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div style="position: relative">
                          现货发货<i class="el-icon-question" />
                        </div>
                        <div slot="content">
                          统计前一天6:00至当天6:00由现货发货的商品，包含发货出库、售后寄出。
                        </div>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>
                        <div>{{ row.not_evaluate_inventory_num }}/</div>
                        <div>{{ row.not_evaluate_inventory_price }}</div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="商品履约" name="fulfillment">
          <!-- 商品履约 -->
          <div class="detail amount">
            <div class="content">
              <YsDataTable
                ref="tableFulfillmentRef"
                v-model="refreshFulfillment"
                :init-params="initParamsFulfillment"
                :list="searchListFulfillment"
                :columns="columnsFulfillment"
                :fetch-method="fetchMethodFulfillment"
                page-size-alias="page_size"
                :page-sizes="[5, 10, 20, 30, 50, 100]"
                :page-size="5"
                :button-list="buttonListFulfillment"
                use-data-field
                max-height="580"
                @on-page-change="handlePageChange"
                @on-change="getSearchFulfillmentParams"
              >
                <template #goods_img="{ row }">
                  <div
                    class="goods-img"
                    @click="handleViewImages([row.main_img])"
                  >
                    <img
                      :src="row.main_img"
                      style="
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: cover;
                      "
                    />
                  </div>
                </template>
                <template #delivery_accuracy="{ row }">
                  <el-button
                    type="text"
                    size="small"
                    @click="handleSkuDetailsClick(row)"
                  >
                    {{ row.delivery_accuracy }}
                  </el-button>
                </template>
                <template #not_evaluate_inventory_num="{ row }">
                  <div>
                    {{ row.not_evaluate_inventory_num }} /
                    {{ row.not_evaluate_inventory_price }}
                  </div>
                </template>
              </YsDataTable>
            </div>
          </div></el-tab-pane
        >
      </el-tabs>
      <el-collapse-transition>
        <!-- 商品明细 -->
        <div class="detail amount">
          <div
            class="header"
            style="cursor: pointer"
            @click="goodsDetailShow = !goodsDetailShow"
          >
            商品明细
            <el-button
              :icon="
                goodsDetailShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
              type="text"
              style="margin-left: 8px; font-size: 22px"
            />
          </div>
          <div v-show="goodsDetailShow" class="content">
            <el-tabs
              v-model="activeName"
              :stretch="true"
              @tab-click="handleClickTag"
            >
              <el-tab-pane
                v-for="item in resData.options_report_detail_type"
                :key="item.value"
                :label="item.label"
                :name="item.value"
              >
              </el-tab-pane>
            </el-tabs>
            <YsDataTable
              ref="tableRef"
              v-model="refresh"
              :init-params="initParams"
              :list="searchList"
              :dep-option-map="optionsMap"
              :columns="columns"
              :fetch-method="fetchMethod"
              page-size-alias="page_size"
              :button-list="buttonList"
              use-data-field
              @on-change="getSearchParams"
              @on-fetch-success="handleFetchSuccess"
            >
              <template #table-title>
                <div class="header">
                  数据列表 共{{ goodsDetailAmount.sum_num }}件，计￥{{
                    goodsDetailAmount.sum_price
                  }}元
                </div>
              </template>
              <template #goods_img="{ row }">
                <div
                  class="goods-img"
                  @click="handleViewImages([row.goods_img])"
                >
                  <img
                    :src="row.goods_img"
                    style="max-width: 100%; max-height: 100%; object-fit: cover"
                  />
                </div>
              </template>

              <template #wcgPlan="{ row }">
                <div class="wcg-plan">
                  <span class="wcg_plan_id">
                    {{ row.planid }}
                  </span>
                  <span class="ptype">
                    {{ row.ptype }}
                    <span v-if="row.is_dispense" style="color: #479ce8">
                      （ 小店分发）
                    </span>
                  </span>
                  <span class="effect-time">
                    {{ row.effect_time }}
                  </span>
                </div>
              </template>
              <template #wcgOrder="{ row }">
                <div class="wcg-plan">
                  <span class="woid">
                    {{ row.woid }}
                  </span>
                  <span class="wcg-sub-time">
                    {{ row.wcg_sub_time }}
                  </span>
                </div>
              </template>
              <template #procurementOrderSubmissionTime="{ row }">
                <div class="wcg-plan">
                  <span class="woid">
                    {{ row.woid }}
                  </span>
                  <span class="wcg-sub-datetime">
                    {{ row.wcg_sub_datetime }}
                  </span>
                </div>
              </template>
              <template #performance_time="{ row }">
                <div class="wcg-plan">
                  <span class="woid">
                    {{ row.woid }}
                  </span>
                  <span class="wcg-sub-time">
                    {{ row.wcg_sub_time }}
                  </span>
                </div>
              </template>
            </YsDataTable>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <!-- 准确率明细弹框 -->
    <el-dialog
      :visible.sync="detailsDialog"
      append-to-body
      :title="detailsData.type === 1 ? '货期准确率明细' : '商品货期准确率明细'"
    >
      <div style="padding-bottom: 20px; font-size: 16px">
        <span
          >需求日期：{{
            detailsData.detail.demanded_date ||
            detailsData.detail.str_demanded_date
          }}</span
        >
        <span style="margin-left: 100px"
          >商家：{{ detailsData.detail.supply_name }}</span
        >
      </div>
      <div
        v-if="detailsData.type === 2 && detailsData.detail"
        style="display: flex; padding-bottom: 20px; padding-top: 20px"
      >
        <img
          class="goods-img"
          :src="detailsData.detail.main_img"
          style="
            width: 100px;
            height: 100px;
            object-fit: cover;
            flex-shrink: 0;
            margin-right: 20px;
          "
          @click="handleViewImages([detailsData.detail.main_img])"
        />
        <div style="line-height: 35px">
          <div>{{ detailsData.detail.goods_name }}</div>
          <div>
            款号：{{ detailsData.detail.goods_kh }}
            <span style="padding-left: 10px">货号：</span
            >{{ detailsData.detail.goods_no }}
          </div>
          <div>
            颜色：{{ detailsData.detail.si_val }}
            <span style="padding-left: 10px">尺码：</span
            >{{ detailsData.detail.co_val }}
          </div>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        v-loading="detailsLoading"
        border
        :data="detailsData.list"
        style="width: 100%"
        show-summary
        :summary-method="detailsSummaryResults"
      >
        <el-table-column prop="delivery_day" label="货期" align="center">
        </el-table-column>
        <el-table-column
          prop="delivery_time"
          label="承诺发货日期"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="total_plan_price"
          label="需求金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="plan_price_rate"
          label="需求金额占比"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="delivery_plan_price"
          label="货期内已履约金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="delivery_accuracy"
          label="货期准确率"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="delivery_generate_status"
          label="统计状态"
          align="center"
        >
          <template #header>
            <el-tooltip class="item" effect="dark" placement="top">
              <div style="position: relative">
                统计状态<i class="el-icon-question" />
              </div>
              <div slot="content">
                <div>当前时间超过承诺发货日期时</div>
                <div>统计状态为“已生成”，否则为“统计中</div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  postReportDetailSummary,
  postReportGoodsDetail,
  postGetSkuPerformanceList,
  postDeliveryAccuracyDetails,
  postSkuDeliveryAccuracyDetails,
  getGetDeliveryConfig,
} from "@/openapi/erp/performanceReport.js";
import apiBaseURL from "@/utils/baseUrl.js";

// 商品明细搜索列表以及cloumns
const searchListWrap = {
  // 前置仓发货
  tab1: [
    {
      tag: "input",
      label: "款号",
      field: "goods_kh_like",
    },
    {
      tag: "input",
      label: "货号",
      field: "goods_no",
    },
    {
      tag: "input",
      label: "SKU编码",
      field: "sku",
    },
  ],
  // 订货单计划代采 待开单 已断货
  tab2: [
    {
      tag: "input",
      label: "款号",
      field: "goods_kh_like",
    },
    {
      tag: "input",
      label: "货号",
      field: "goods_no",
    },
    {
      tag: "input",
      label: "SKU编码",
      field: "sku",
    },
    {
      tag: "input",
      label: "代采计划单号",
      field: "plan_id",
    },
    {
      tag: "select",
      label: "货期",
      field: "delivery_day",
      optionsField: "delivery_config",
    },
  ],
  // 订货单正常品已入库（含坏账） 订单欠货 配送在途 退换货 转抵扣  已退款
  tab3: [
    {
      tag: "input",
      label: "款号",
      field: "goods_kh_like",
    },
    {
      tag: "input",
      label: "货号",
      field: "goods_no",
    },
    {
      tag: "input",
      label: "SKU编码",
      field: "sku",
    },
    {
      tag: "input",
      label: "代采计划单号",
      field: "plan_id",
    },
    {
      tag: "input",
      label: "代采单号",
      field: "order_id",
    },
    {
      tag: "select",
      label: "来源",
      field: "source",
      optionsField: "options_source",
    },
    {
      tag: "select",
      label: "货期",
      field: "delivery_day",
      optionsField: "delivery_config",
    },
  ],
};
const generateColumns = [
  {
    label: "商品名称",
    prop: "goods_name",
  },
  {
    label: "款号",
    prop: "goods_kh",
  },
  {
    label: "货号",
    prop: "goods_no",
  },
  {
    label: "SKU编码",
    prop: "sku",
  },
  {
    label: "颜色",
    prop: "co_val",
  },
  {
    label: "尺码",
    prop: "si_val",
  },
  {
    label: "货期",
    prop: "delivery_day",
  },
  {
    label: "承诺发货日期",
    prop: "delivery_time",
  },
  {
    label: "计划代采单价",
    prop: "plan_price",
  },
  {
    label: "代采单价",
    prop: "price",
  },
  {
    label: "数量",
    prop: "num",
  },
  {
    label: "金额小计",
    prop: "plan_price_sum",
  },
];
const columnsWrap = {
  // 前置仓发货
  columns1: [
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "代采单价",
      prop: "price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "金额小计",
      prop: "plan_price_sum",
    },
    {
      label: "代采订单/提交时间",
      slot: "procurementOrderSubmissionTime",
    },
    {
      label: "波次单号",
      prop: "wave_picking_no",
    },
    {
      label: "出库类型",
      prop: "str_out_type",
    },
    {
      label: "出库时间",
      prop: "out_stock_time",
    },
  ],
  // 订货单计划代采、待开单
  columns2: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "需求时间",
      prop: "demanded_date",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "货期",
      prop: "delivery_day",
    },
    {
      label: "承诺发货日期",
      prop: "delivery_time",
    },
    {
      label: "计划代采单价",
      prop: "plan_price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "金额小计",
      prop: "plan_price_sum",
    },
  ],
  // 订货单正常品已入库（含坏账）
  columns3: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "履约状态",
      prop: "performance_status",
    },
    {
      label: "履约时间",
      prop: "performance_time",
      renderHeader(h) {
        return h(
          "el-tooltip",
          {
            props: {
              content: `履约状态为“正常品入库”时，取首次以正常品入库的包裹生成时间（快递包裹取快递揽收时间，无揽收时间时取仓库接收时间；无揽收时间且无接收时间时取最早的点货批次创建时间），若无则取入库时间。 履约状态为“申请坏账”时，取首次申请坏账时间。`,
              placement: "top-start",
            },
          },
          [
            h("span", [
              "履约时间",
              h("i", {
                class: "el-icon-question",
              }),
            ]),
          ]
        );
      },
    },
    {
      label: "打标id",
      prop: "dbid",
    },
  ],
  //  订单欠货 配送在途 退换货
  columns4: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "操作时间",
      prop: "operate_time",
    },
  ],
  // 已断货
  columns5: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "货期",
      prop: "delivery_day",
    },
    {
      label: "承诺发货日期",
      prop: "delivery_time",
    },
    {
      label: "计划代采单价",
      prop: "plan_price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "金额小计",
      prop: "plan_price_sum",
    },
    {
      label: "断货类型",
      prop: "stop_type",
    },
    {
      label: "断货时间",
      prop: "stop_time",
    },
  ],
  // 转抵扣
  columns6: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "抵扣金额",
      prop: "ded_price",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "操作时间",
      prop: "operate_time",
    },
  ],
  // 已退款
  columns7: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "退款金额",
      prop: "refund_price",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "退款提交时间",
      prop: "refund_submit_time",
    },
  ],
  // 现货发货
  columns8: [
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "代采单价",
      prop: "price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "金额小计",
      prop: "plan_price_sum",
    },
    {
      label: "波次单号",
      prop: "wave_picking_no",
    },
    {
      label: "出库类型",
      prop: "str_out_type",
    },
    {
      label: "出库时间",
      prop: "out_stock_time",
    },
  ],
  // 次品入库
  columns9: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "货期",
      prop: "delivery_day",
    },
    {
      label: "承诺发货日期",
      prop: "delivery_time",
    },
    {
      label: "计划代采单价",
      prop: "plan_price",
    },
    {
      label: "代采单价",
      prop: "price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "金额小计",
      prop: "plan_price_sum",
    },
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "入库时间",
      prop: "stock_in_create_time",
    },
    {
      label: "打标id",
      prop: "dbid",
    },
  ],
};

export default {
  name: "PerformanceReportDetail",
  data() {
    return {
      queryData: null,
      resData: { options_report_detail_type: [] },
      activeName: "1",
      goodsDetailAmount: {
        sum_num: 0,
        sum_price: 0.0,
      },
      refresh: false,
      fetchMethod: postReportGoodsDetail,
      searchList: searchListWrap.tab1,
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: this.exportGoodsDetail,
          },
        },
      ],
      optionsMap: {},
      columns: columnsWrap.columns1,
      searchParams: {},
      refreshFulfillment: false,
      initParamsFulfillment: { page_size: 5, demanded_date: [] },
      fetchMethodFulfillment: postGetSkuPerformanceList,
      searchListFulfillment: searchListWrap.tab1,
      buttonListFulfillment: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: this.exportGoodsFulfillmentDetail,
          },
        },
        {
          tag: "button",
          text: "导出货期明细",
          props: {
            type: "success",
          },
          event: {
            handler: this.exportWcgPlanDeliveryScheduleDetails,
          },
        },
      ],
      columnsFulfillment: [
        {
          label: "图片",
          slot: "goods_img",
          width: 120,
        },
        {
          label: "商品名称",
          prop: "goods_name",
        },
        {
          label: "款号",
          prop: "goods_kh",
        },
        {
          label: "货号",
          prop: "goods_no",
        },
        {
          label: "SKU编码",
          prop: "sku",
        },
        {
          label: "颜色",
          prop: "co_val",
        },
        {
          label: "尺码",
          prop: "si_val",
        },
        {
          label: "24H履约率",
          prop: "24h_performance_rate",
        },
        {
          label: "48H履约率",
          prop: "48h_performance_rate",
        },
        {
          label: "360H履约率",
          prop: "360h_performance_rate",
        },
        {
          label: "总履约率",
          prop: "final_performance_rate",
        },
        {
          label: "货期准确率",
          slot: "delivery_accuracy",
          popover: {
            content:
              "统计该SKU在货期内完成履约的金额占比，货期准确率=货期内已履约金额/货期需求金额*100%”",
          },
        },
        {
          label: "总需求",
          prop: "children",
          columns: [
            {
              label: "前置仓发货",
              prop: "str_all_pre",
            },
            {
              label: "现货发货",
              prop: "str_all_inventory",
            },
            {
              label: "订货单计划代采",
              prop: "str_all_plan",
            },
            {
              label: "小计",
              prop: "str_all_sum",
            },
          ],
        },
        {
          label: "已履约",
          prop: "children",
          columns: [
            {
              label: "前置仓发货",
              prop: "str_done_pre",
            },
            {
              label: "现货发货",
              prop: "str_done_inventory",
            },
            {
              label: "订货单正常品已入库（含坏账）",
              prop: "str_done_plan",
            },
            {
              label: "小计",
              prop: "str_done_sum",
            },
          ],
        },
        {
          label: "待履约",
          prop: "children",
          columns: [
            {
              label: "待开单",
              prop: "str_doing_plan",
            },
            {
              label: "订单欠货",
              prop: "str_doing_owe",
            },
            {
              label: "配送在途",
              prop: "str_doing_on_way",
            },
            {
              label: "退换货",
              prop: "str_doing_reject",
            },

            {
              label: "小计",
              prop: "str_doing_sum",
            },
          ],
        },
        {
          label: "未履约",
          prop: "children",
          columns: [
            {
              label: "已断货",
              prop: "str_yet_stopped",
            },
            {
              label: "转抵扣",
              prop: "str_yet_ded",
            },
            {
              label: "已退款",
              prop: "str_yet_refund",
            },
            {
              label: "次品入库",
              prop: "str_yet_cpin",
              renderHeader(h) {
                return h(
                  "el-tooltip",
                  {
                    props: {
                      content: `统计对应需求时间的代采计划商品，因开单后售前首次以次品入库或退换货欠货首次以次品入库，均计入"次品入库"里；注意：恢复欠货并通过审核后，因商品重新回到代采欠货/在途库存，需要消掉对于的"次品入库"数据，并将数据返回到相应的表头记录里。`,
                      placement: "top",
                      effect: "dark",
                    },
                  },
                  [
                    h("span", [
                      "次品入库",
                      h("i", {
                        class: "el-icon-question",
                      }),
                    ]),
                  ]
                );
              },
            },
            {
              label: "小计",
              prop: "str_yet_sum",
            },
          ],
        },
        {
          label: "不考核",
          prop: "children",
          columns: [
            {
              label: "现货发货",
              slot: "not_evaluate_inventory_num",
            },
          ],
        },
      ],
      // 商品明细显示隐藏
      goodsDetailShow: true,

      detailsLoading: false,
      detailsData: {
        type: 0,
        detail: {
          demanded_date: "",
          supply_name: "",
        },
        list: [],
      },
      detailsDialog: false,
      activeTab: "sumUp",
    };
  },
  computed: {
    initParams() {
      return {
        ...this.queryData,
        ...this.searchParams,
        detail_type: this.activeName,
      };
    },
  },
  watch: {
    activeName(value) {
      // 不同的tab显示不同的搜索项和展示列表
      switch (value) {
        // 前置仓发货
        case "1":
          this.searchList = searchListWrap.tab1;
          this.columns = columnsWrap.columns1;
          break;
        // 订货单计划代采
        case "2":
        case "4": // 待开单
          this.searchList = searchListWrap.tab2;
          this.columns = columnsWrap.columns2;
          break;
        // 订货单正常品已入库（含坏账）
        case "3":
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns3;
          break;
        // 订单欠货
        case "5":
        case "6": // 配送在途
        case "7": // 退换货
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns4;
          break;
        // 已断货
        case "8":
          this.searchList = searchListWrap.tab2;
          this.columns = columnsWrap.columns5;
          break;
        // 转抵扣
        case "9":
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns6;
          break;
        // 已退款
        case "10":
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns7;
          break;
        // 现货发货
        case "11":
          this.searchList = searchListWrap.tab1;
          this.columns = columnsWrap.columns8;
          break;
        // 次品入库
        case "12":
          this.searchList = searchListWrap.tab1;
          this.columns = columnsWrap.columns9;
          console.warn("次品入库", this.searchList, this.columns);
          break;
        // 默认tab1
        default:
          this.searchList = searchListWrap.tab1;
          this.columns = columnsWrap.columns1;
          break;
      }
    },
  },
  created() {
    const { supply_id: supplyId, demanded_date: demandedDate } =
      this.$route.query;

    this.queryData = {
      supply_id: supplyId,
      demanded_date: demandedDate,
    };
    // 商品履约初始化数据
    this.initParamsFulfillment = {
      page_size: 5,
      supply_id: supplyId,
      demanded_date: [demandedDate, demandedDate],
    };
    this.fetchData();
  },
  methods: {
    fetchData() {
      postReportDetailSummary(this.queryData).then((res) => {
        const { options_source: optionsSource, ...rest } = res;
        this.resData = rest;
        this.optionsMap = { options_source: optionsSource };
        // 获取商品明细数据
        this.refresh = true;
        // 获取商品履约明细
        this.refreshFulfillment = true;

        this.getDeliveryConfigList(this.optionsMap);
      });
    },
    // 获取货期设置下拉数据
    getDeliveryConfigList(_optionsMap) {
      getGetDeliveryConfig().then((res) => {
        const _delivery_config = res.delivery_config.map((e) => ({
          label: e.value,
          value: e.key,
        }));
        this.optionsMap = {
          ..._optionsMap,
          delivery_config: _delivery_config,
        };
      });
    },
    // 切换tag
    handleClickTag(tag) {
      const { name } = tag;
      this.activeName = name;
      // 清空分页选项
      this.$refs.tableRef.initPageValue();
      this.refresh = true;
    },
    // 请求商品明细成功
    handleFetchSuccess(res) {
      const { sum_num: sumNum, sum_price: sumPrice } = res;
      this.goodsDetailAmount = {
        sum_num: sumNum,
        sum_price: sumPrice,
      };
    },
    // 搜索参数
    getSearchParams(params) {
      this.searchParams = params;
    },
    // 显示图片
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
    // 导出商品明细列表
    exportGoodsDetail() {
      postReportGoodsDetail({
        ...this.initParams,
        is_export: 1,
      })
        .then((res) => {
          const { file } = res;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },
    // 搜索参数
    getSearchFulfillmentParams(params) {
      this.initParamsFulfillment = params;
    },
    // 导出商品履约明细列表
    exportGoodsFulfillmentDetail() {
      postGetSkuPerformanceList({
        ...this.initParamsFulfillment,
        is_export: 1,
      })
        .then((res) => {
          const { file } = res;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },
    // 导出商品履约 - 导出货期明细
    exportWcgPlanDeliveryScheduleDetails() {
      postGetSkuPerformanceList({
        ...this.initParamsFulfillment,
        is_export: 2,
      })
        .then((res) => {
          const { file } = res;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },
    // 履约分页改变
    handlePageChange(pageParams) {
      this.initParamsFulfillment = {
        ...this.initParamsFulfillment,
        ...pageParams,
      };
    },
    handleDeliveryAccuracyClick(e) {
      this.detailsLoading = true;
      this.detailsDialog = true;
      this.detailsData = {};
      postDeliveryAccuracyDetails({
        supply_id: e.supply_id,
        demanded_date: dayjs(e.demanded_date * 1000).format("YYYY-MM-DD"),
      })
        .then((res) => {
          this.detailsData = {
            ...res,
            type: 1,
          };
        })
        .finally(() => {
          this.detailsLoading = false;
        });
    },

    handleSkuDetailsClick(e) {
      this.detailsLoading = true;
      this.detailsDialog = true;
      this.detailsData = {};
      postSkuDeliveryAccuracyDetails({
        supply_id: e.supply_id,
        sku: e.sku,
        demanded_date: [
          dayjs(e.demanded_date * 1000).format("YYYY-MM-DD 00:00:00"),
          dayjs(e.demanded_date * 1000).format("YYYY-MM-DD 23:59:59"),
        ],
      })
        .then((res) => {
          this.detailsData = {
            ...res,
            type: 2,
          };
        })
        .finally(() => {
          this.detailsLoading = false;
        });
    },

    detailsSummaryResults(param) {
      const { columns } = param;
      const { sum_of_list: sumOfList } = this.detailsData;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const { property } = column;
        if (Object.keys(sumOfList).includes(property)) {
          sums[index] = sumOfList[property].replace("/", "/\n");
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped lang="less">
.performance-report-detail {
  position: relative;
}

.detail {
  position: relative;
  margin-top: 12px;

  .header {
    background: #f3f3f3;
    height: 40px;
    line-height: 40px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .content {
    .wcg-plan {
      display: flex;
      flex-direction: column;
    }
  }

  .goods-img {
    height: 80px;
    width: 80px;
    cursor: pointer;
    margin: 0 auto;
  }
}

/deep/ .el-table .el-table__cell.performance {
  background: #aeebcf;
}

/deep/ .el-table .el-table__cell.await-performance {
  background: #bed3fc;
}

/deep/ .el-table .el-table__cell.default {
  background: #f0c98c;
}
</style>



// WEBPACK FOOTER //
// src/pages/PerformanceReport/PerformanceReportDetail.vue